import { render, staticRenderFns } from "./VSincronizacionauditoriaModals.vue?vue&type=template&id=70b89fac"
import script from "./VSincronizacionauditoriaModals.vue?vue&type=script&lang=js"
export * from "./VSincronizacionauditoriaModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports